import request from '@/utils/request'

const BaseUrl = '/bizPartnerBudgetTask'

// 保存任务
export function addTask(data) {
  return request({
    url: `${BaseUrl}/save`,
    method: 'post',
    data
  })
}

// 通过id删除任务
export function deleteTaskById(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete',
  })
}

// 通过id获取单个任务
export function findTaskById(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

// 修改任务
export function modifyTask(data) {
  return request({
    url: `${BaseUrl}/update`,
    method: 'put',
    data
  })
}

// 删除任务分拆
export function removeTask(id) {
  return request({
    url: `${BaseUrl}/deleteTaskSplitting/${id}`,
    method: 'delete',
  })
}

// 删除商机预测
export function removeBusinessForecast(id) {
  return request({
    url: `${BaseUrl}/deleteBusiness/${id}`,
    method: 'delete',
  })
}

// 删除费用预算
export function removeCostForecast(id) {
  return request({
    url: `${BaseUrl}/deleteCostBudget/${id}`,
    method: 'delete',
  })
}
// 根据年度查询季度
export function getQuarterList(params) {
  return request({
    url: '/quarter/list',
    method: 'get',
    params
  })
}